var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgDeliveryNote2 = function SvgDeliveryNote2(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24.155 31.312",
    ref: ref
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "lieferschein (1)"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 39"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 38"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M22.815 4.477h-4.026V8.5a1.343 1.343 0 0 1-1.343 1.343H6.713A1.343 1.343 0 0 1 5.37 8.5V4.477H1.344A1.343 1.343 0 0 0 .001 5.82v24.149a1.343 1.343 0 0 0 1.343 1.343h21.469a1.343 1.343 0 0 0 1.343-1.343V5.817a1.34 1.34 0 0 0-1.341-1.34M7.661 25.548a1.345 1.345 0 1 1 .391-.949 1.35 1.35 0 0 1-.391.949m0-5.366a1.345 1.345 0 1 1 .391-.949 1.35 1.35 0 0 1-.391.944Zm0-5.366a1.342 1.342 0 1 1-.949-2.289 1.336 1.336 0 0 1 1.34 1.34 1.35 1.35 0 0 1-.391.948Zm9.784 11.127h-5.366a1.343 1.343 0 0 1 0-2.686h5.366a1.343 1.343 0 1 1 0 2.686m0-5.37h-5.366a1.343 1.343 0 1 1 0-2.686h5.366a1.343 1.343 0 1 1 0 2.686m0-5.366h-5.366a1.342 1.342 0 1 1 0-2.683h5.366a1.342 1.342 0 1 1 0 2.683",
    "data-name": "Pfad 67"
  }))), /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 41"
  }, /*#__PURE__*/React.createElement("g", {
    "data-name": "Gruppe 40"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M14.763 4.474a1.343 1.343 0 0 1-1.343-1.343V1.343a1.342 1.342 0 1 0-2.683 0v1.788a1.343 1.343 0 0 1-1.343 1.343H8.05v2.683h8.05V4.474Z",
    "data-name": "Pfad 68"
  }))))));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgDeliveryNote2);
export default ForwardRef;